/* 展示アーカイブ: 「開催中 / 開催予定 / 過去の展示」のタブ切り替え。
   JS が無い場合は全区分が縦に並び、上部はページ内リンクとして働く。
   URL のハッシュ(#now-showing / #past、3 区分なら #current / #upcoming / #past)を開いたときはその区分を表示する。
   V1.25 までの #Exhibitions-<区分>-<section id> も受ける(V1.27 でセクション ID 入りのハッシュは出さなくなった)。 */
if (!customElements.get('exhibition-archive-tabs')) {
  customElements.define(
    'exhibition-archive-tabs',
    class ExhibitionArchiveTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        if (!this.tabs.length || !this.panels.length) return;

        // para V1.16(AX-01): tablist の子は tab だけにする(li は presentation)。左右・Home・End キーで移動
        const tablist = this.querySelector('.exhibition-archive__tabs');
        tablist.setAttribute('role', 'tablist');
        tablist.setAttribute('aria-label', '展示の区分');
        this.tabs.forEach((tab) => {
          const panel = this.panelFor(tab.dataset.tab);
          if (tab.parentElement && tab.parentElement.tagName === 'LI') tab.parentElement.setAttribute('role', 'presentation');
          tab.setAttribute('role', 'tab');
          tab.id = `${panel.id}-tab`;
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.select(tab.dataset.tab, true);
          });
          tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
        });

        // 初期表示: URL のハッシュ > 件数のある最初の区分 > 先頭
        const fromHash = this.panelForHash(window.location.hash);
        const firstWithItems = this.tabs.find((tab) => Number(tab.dataset.count) > 0);
        const initial = fromHash ? fromHash.dataset.panel : (firstWithItems || this.tabs[0]).dataset.tab;
        this.classList.add('is-enhanced');
        this.select(initial, false);
        // para V1.26: 同じページでメニューの NOW SHOWING / PAST(#now-showing / #past)を押したときも区分を切り替える
        // 戻る/進む(タブを押すと pushState で履歴に積む)でも区分を切り替える
        const onNav = () => {
          const target = this.panelForHash(window.location.hash);
          if (target) this.select(target.dataset.panel, false);
        };
        window.addEventListener('hashchange', onNav);
        window.addEventListener('popstate', onNav);
      }

      // para V1.26: ハッシュ → 区分。固定の #now-showing / #past のほか、V1.25 までの #Exhibitions-<区分>-<セクション ID> も受ける
      panelForHash(hash) {
        if (!hash) return null;
        const exact = this.panels.find((panel) => `#${panel.id}` === hash);
        if (exact) return exact;
        // para V1.27: 2 区分と 3 区分の固定名を相互に読み替える(#current / #upcoming ⇔ #now-showing)
        if (hash === '#now-showing') return this.panelFor('current') || this.panelFor('upcoming');
        const m = hash.match(/^#(?:Exhibitions-)?(current|upcoming|past)(?:-|$)/);
        if (!m) return null;
        const legacy = m[1] === 'past' ? 'past' : 'now-showing';
        return this.panelFor(m[1]) || this.panelFor(legacy);
      }

      panelFor(id) {
        return this.panels.find((panel) => panel.dataset.panel === id);
      }

      select(id, updateHash) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.tab === id;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== id;
        });
        if (updateHash) {
          const panel = this.panelFor(id);
          if (panel && window.location.hash !== `#${panel.id}`) history.pushState(null, '', `#${panel.id}`);
        }
      }

      onKeydown(event, tab) {
        const index = this.tabs.indexOf(tab);
        let next = null;
        if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        if (event.key === 'Home') next = this.tabs[0];
        if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        this.select(next.dataset.tab, true);
        next.focus();
      }
    }
  );
}
